/*
 * Copyright (c) 2023 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */


/**
 * Constants for the GlobalStrings to maintain messages and error string for the application
 */
export default class GlobalStrings {
    public static ERROR_MESSAGES={
        'GATEWAY_PLATFORM_VERSION_NOT_AVAILABLE': 'Platform version is not available in uploaded configuration.',
        'GATEWAY_MODEL_NOT_AVAILABLE': 'Gateway model is not available in uploaded configuration.',
        'GATEWAY_MODEL_NOT_PART_OF_DEFINED_LIST': 'Gateway model for uploaded configuration is not part of pre-defined list of gateway models.',
        'GATEWAY_SERIAL_NOT_AVAILABLE': 'Serial number is not available in uploaded configuration.'
    };
    public static getErrorMessage(errorCode: string):string
    {    
        let errorMessage = GlobalStrings.ERROR_MESSAGES[errorCode as keyof typeof GlobalStrings.ERROR_MESSAGES];
        return errorMessage
    }
}